/* ============================================
   Sticky Add to Cart Bar — sticky-atc-bar.js
   Guardar en: assets/sticky-atc-bar.js
   ============================================ */

(function () {
  'use strict';

  const bar     = document.getElementById('sticky-atc-bar');
  const btn     = document.getElementById('sticky-atc-btn');

  // Referencia al botón ATC original de la página de producto
  // Shopify Dawn usa #ProductSubmitButton; ajusta si tu tema es distinto
  const mainBtn = document.querySelector(
    '#ProductSubmitButton, [name="add"], form[action="/cart/add"] button[type="submit"]'
  );

  if (!bar || !btn) return;

  /* --------------------------------------------------
     1. Mostrar barra cuando el botón principal sale
        del viewport (usuario hizo scroll hacia abajo)
  -------------------------------------------------- */
  if (mainBtn) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Botón principal visible → ocultar barra sticky
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            // Botón principal fuera de vista → mostrar barra sticky
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(mainBtn);
  } else {
    // Fallback: mostrar siempre si no existe botón principal
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
  }

  /* --------------------------------------------------
     2. Añadir al carrito via AJAX al hacer click
  -------------------------------------------------- */
  btn.addEventListener('click', function () {
    const variantId = btn.getAttribute('data-product-id');
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Añadiendo...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Error al añadir');
        return res.json();
      })
      .then(function () {
        // Feedback visual de éxito
        btn.textContent = '✓ Añadido';
        btn.classList.add('is-added');

        // Actualizar contador del carrito (compatible con Dawn y la mayoría de temas)
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // También dispara el evento nativo de Shopify si existe
        if (typeof theme !== 'undefined' && theme.cart) {
          theme.cart.getCart();
        }

        setTimeout(function () {
          btn.textContent = 'Agregar al carrito';
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2500);
      })
      .catch(function () {
        btn.textContent = 'Reintentar';
        btn.disabled = false;
      });
  });

  /* --------------------------------------------------
     3. Sincronizar variante seleccionada
        (si el producto tiene variantes: talla, color, etc.)
  -------------------------------------------------- */
  document.addEventListener('variant:changed', function (e) {
    if (!e.detail || !e.detail.variant) return;
    const v = e.detail.variant;

    btn.setAttribute('data-product-id', v.id);
    btn.disabled = !v.available;
    btn.textContent = v.available ? 'Agregar al carrito' : 'Agotado';

    // Actualizar precio en la barra
    const priceEl = bar.querySelector('.sticky-atc-bar__price--current');
    if (priceEl && v.price) {
      // Formatear precio en CLP (ajusta locale si usas otra moneda)
      priceEl.textContent = new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
      }).format(v.price / 100);
    }
  });

})();
